import { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { handleError } from 'src/contexts/utils/handleError';
import { SET_LOADING } from 'src/contexts/types';
import { GET_CONTACT } from '../constants/actions';
import type { TContactActionTypes } from '../types';
import type { IContact } from 'src/interfaces/contact';

export const getContact = async (
    dispatch: Dispatch<TContactActionTypes>,
    contactId: string
): Promise<void> => {
    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.post(
            `/contacts/${contactId}/read`,
            {},
            HEADERS({
                isReadPermissionNecessary: true,
            })
        );

        dispatch({
            type: GET_CONTACT,
            payload: res.data.data as IContact,
        });
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
